import * as React from 'react';

import PageRoutes from '@components/Routes/PageRoutes';
import GlobalStyle from '@components/GlobalStyle';
import { withDependencies } from '@services/withDependencies';
import { useServiceResolver } from '@services/useServiceResolver';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { withEnabledResizer } from '@components/MutationEffect/withEnabledResizer';

/**
 * App component
 *
 * @requires ServiceContext
 * @requires WhitelabelAware
 * @requires AppContext
 */
const AppComponent: React.FC = () => {
    const { performanceService, sdkEffect } = useServiceResolver();

    React.useEffect(() => {
        sdkEffect.onSpaLoad(Date.now());
        performanceService.measureLanding();
    }, []);

    return (
        <BrowserRouter>
            <Switch>
                <Route path="/">
                    <PageRoutes />
                    <GlobalStyle />
                </Route>
            </Switch>
        </BrowserRouter>
    );
};

AppComponent.displayName = 'App';

export const App = withDependencies(withEnabledResizer(AppComponent));
